import  { HANDLE_JOB_CARD_AMC_STATUS, RESET } from "../actions";
import moment from "moment";

const initialState = {
    startDate: moment().subtract(6, "month"),
    endDate: moment().subtract(3, "month").add(10, "days"),
    filterType: 1,
    sort: "desc",
    jobCard: [],

    toggleTable: true,

    filter: 1,
    searchText: ""
};

const Report = (state = initialState, action) => {
    switch(action.type) {
        case HANDLE_JOB_CARD_AMC_STATUS : 
            return {
                ...state,
                ...action.data
            }
        case RESET :
            return initialState
        default:
            return state;
    }
}

export default Report;